import { Empty } from "antd";
import { useMemo } from "react";

import { ROUTES } from "@/constants";
import { useSelectedDateSalary } from "@/features/Dashboard";
import { useProtectedUserRoleSelector } from "@/hooks/redux";
import { Header } from "@/shared/layout";
import { MainContainer } from "@/shared/layout/Layout";
import { BlockList } from "@/shared/pageComposition/BlockList";
import { Meta } from "@/shared/seo";

import { useMemberInfoData } from "./hooks/useMemberInfoData";
import { getMemberInfoBlocks, MemberInfoModel } from "./MemberInfo.blocks";
import { getMemberInfoCapabilities } from "./MemberInfo.policy";
import { StyledMemberContainer } from "./Styled";

function MemberInfo() {
    const role = useProtectedUserRoleSelector();
    const capabilities = getMemberInfoCapabilities(role);

    const memberData = useMemberInfoData();
    const { selectedDateSalary, setSelectedDateSalary } =
        useSelectedDateSalary();

    const model: MemberInfoModel = useMemo(
        () => ({
            capabilities,
            memberData,
            salary: {
                selectedDateSalary,
                onSalaryDataChange: setSelectedDateSalary,
            },
        }),
        [capabilities, memberData, selectedDateSalary, setSelectedDateSalary],
    );

    const blocks = useMemo(() => getMemberInfoBlocks(model), [model]);

    if (!memberData.member || !memberData.routeId) {
        return (
            <>
                <Meta title="Member info" />
                <Header path={ROUTES.Team} />
                <MainContainer>
                    <Empty description="Користувача не знайдено" />
                </MainContainer>
            </>
        );
    }

    return (
        <>
            <Meta title="Member info" />
            <Header
                path={ROUTES.Team}
                titleLoading={!memberData.dashboardLoaded}
            />
            <MainContainer>
                <StyledMemberContainer>
                    <BlockList blocks={blocks} model={model} />
                </StyledMemberContainer>
            </MainContainer>
        </>
    );
}

export default MemberInfo;
